import axios from "axios";
//import { authHeader } from "./auth-headerService";
import { buildHeaders } from "./_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}payroll/`;

export default {
  // Run payroll for a given period and (optional) list of employee IDs
  runPayroll(payload) {
    // payload: { period: "YYYY-MM", employee_ids: [...] }
    return axios.post(`${API_URL}run`, payload, {
      headers: buildHeaders(),
    });
  },

  fetchRun(params) {
    const query =
      typeof params === "object" && params !== null
        ? params
        : { period: params };
    return axios.get(`${API_URL}run`, {
      headers: buildHeaders(),
      params: query,
    });
  },

  fetchLatestRun() {
    return axios.get(`${API_URL}run/latest`, {
      headers: buildHeaders(),
    });
  },

  approvePayroll(payload) {
    return axios.post(`${API_URL}run/approve`, payload, {
      headers: buildHeaders(),
    });
  },

  fetchPeriodStatus(period) {
    return axios.get(`${API_URL}periods/status`, {
      headers: buildHeaders(),
      params: { period },
    });
  },

  fetchPeriods() {
    return axios.get(`${API_URL}periods`, {
      headers: buildHeaders(),
    });
  },

  closePeriod(period) {
    return axios.post(
      `${API_URL}periods/close`,
      { period },
      { headers: buildHeaders() },
    );
  },

  generateSingle({
    period,
    period_code,
    employee_id,
    email = false,
    force = false,
  }) {
    return axios.post(
      `${API_URL}payslips/generate`,
      { period, period_code, employee_id, email, force },
      { headers: buildHeaders() }
    );
  },

  previewPayslip(params = {}) {
    return axios.get(`${API_URL}payslips/preview`, {
      headers: buildHeaders(),
      params,
      responseType: "blob",
    });
  },

  resendPayslipEmail(payslipId) {
    return axios.post(`${API_URL}payslips/${payslipId}/email`, null, {
      headers: buildHeaders(),
    });
  },

  download(payslipId) {
    return axios.get(`${API_URL}payslips/${payslipId}/download`, {
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  downloadMySlip(payslipId) {
    return axios.get(`${API_URL}payslips/${payslipId}/download-slip`, {
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  bulkDownload(payload) {
    // payload: { period: "YYYY-MM", employee_ids: [1,2,...] }
    return axios.get(`${API_URL}payslips/bulk-download`, {
      headers: buildHeaders(),
      responseType: "blob",
      params: payload,
    });
  },
};
